import { Seaport } from "@opensea/seaport-js";
import type { CreateOrderInput, OrderWithCounter } from "@opensea/seaport-js/lib/types";
import { seaportConf, seaportConduitKey } from "~/application/config";

export class SeaportService {
  public seaport: Seaport;

  constructor(signer: any) {
    if (!signer) throw new Error("signer is null !");
    try {
      this.seaport = new Seaport(signer, {
        seaportVersion: "1.5",
        conduitKeyToConduit: seaportConf,
        overrides: {
          defaultConduitKey: seaportConduitKey,
        },
      });
    } catch (error) {
      console.error("Seaport initialisation Failure", error);
      throw error;
    }
  }

  public async getOrderSignature(
    orderParams: CreateOrderInput,
    offerer: string,
    fulfiller?: string
  ): Promise<OrderWithCounter> {
    try {
      const { executeAllActions } = await this.seaport.createOrder(orderParams, offerer);
      return await executeAllActions();
    } catch (error: unknown) {
      console.error("Error getting order signature:", error);
      throw error;
    }
  }
}
